import {createProjectModel} from 'crm/utils/project-model'
import {fissionInfo, fissionChannel} from './service'

const model = createProjectModel({
    projectNamespace: 'fissionChannelManage',

    state: {
        fissionInfo: null,
    },

    effects: {
        *fissionChannel({payload}, {call}) {
            return yield call(fissionChannel, payload)
        },
        *fissionInfo({payload}, {call, put}) {
            const {data} = yield call(fissionInfo, payload)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.fissionInfo = data
                },
            })
        },
    },
})

export default model
